import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-deep-dive-save-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    FormsModule
  ],
  templateUrl: './deep-dive-save-dialog.component.html',
  styleUrls: ['./deep-dive-save-dialog.component.scss']
})
export class DeepDiveSaveDialogComponent {

  reportName: string = '';

  constructor(
    public dialogRef: MatDialogRef<DeepDiveSaveDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    if (this.reportName.trim()) {
      this.dialogRef.close(this.reportName.trim());
    }
  }
}
